import React from 'react';
import { IconProps } from './types';

export const WarningIcon: React.FC<IconProps> = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        className={className}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.99935 13.3332C10.9449 13.3332 13.3327 10.9454 13.3327 7.99984C13.3327 5.05432 10.9449 2.6665 7.99935 2.6665C5.05383 2.6665 2.66602 5.05432 2.66602 7.99984C2.66602 10.9454 5.05383 13.3332 7.99935 13.3332ZM7.16602 8.00224L7.16602 10.9998H8.83268L8.83268 8.00224H7.16602ZM6.99935 5.99984C6.99935 5.44755 7.44706 4.99984 7.99935 4.99984C8.55163 4.99984 8.99935 5.44755 8.99935 5.99984C8.99935 6.55212 8.55163 6.99984 7.99935 6.99984C7.44706 6.99984 6.99935 6.55212 6.99935 5.99984Z"
            fill="#261B36"
        />
    </svg>
);
